import { render } from "./CallsCardView.vue?vue&type=template&id=2aa234ba"
import script from "./CallsCardView.vue?vue&type=script&lang=js"
export * from "./CallsCardView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__